import { create } from 'zustand';

// Phase 25: Non-persisted Zustand store for referral state.
// Referral state is server-authoritative; persisting to localStorage could cause a stale
// code to survive across browser restarts, potentially misattributing a later visitor.
// sessionStorage is the durable store; this is ephemeral React state for the current session.

interface ReferralState {
  /** The referral code captured from the /invite/:code URL, pending attribution. */
  pendingCode: string | null;
  setPendingCode: (code: string) => void;
  clearReferral: () => void;
}

export const useReferralStore = create<ReferralState>()((set) => ({
  pendingCode: null,
  setPendingCode: (code) => set({ pendingCode: code }),
  clearReferral: () => set({ pendingCode: null }),
}));
